import authInstance from "../utilities/axios/authInstance";

export const allClients = () => authInstance.get('clients');

export const addClient = (client) => authInstance.post('clients', client);

export const searchClients = (client) => authInstance.get('search/clients', {
    params: {
        name: client
    }
});